import Listing from "./listing.container";

export default Listing;
